var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.hideAllNav)?_c('div',[_c('div',{staticClass:"sidebar-container"},[_c('the-sidebar')],1),_c('div',{staticClass:"main-container"},[(!_vm.hideMobileNav)?_c('div',{staticClass:"the-navbar"},[_c('the-navbar')],1):_vm._e(),_c('router-view')],1)]):_c('div',[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }